import React from "react";
import styled from 'styled-components';

import servalProductPhoto1 from '../images/serval/product-photos-serval-1.webp';
import servalProductPhoto2 from '../images/serval/product-photos-serval-2.webp';
import servalProductPhoto3 from '../images/serval/product-photos-serval-3.webp';
import servalProductPhoto4 from '../images/serval/product-photos-serval-4.webp';
import servalProductPhoto5 from '../images/serval/product-photos-serval-5.webp';
import servalProductPhoto6 from '../images/serval/product-photos-serval-6.webp';
import servalProductPhoto7 from '../images/serval/product-photos-serval-7.webp';
import servalProductPhoto8 from '../images/serval/product-photos-serval-8.webp';
import servalProductPhoto9 from '../images/serval/product-photos-serval-9.webp';
import servalProductPhoto10 from '../images/serval/product-photos-serval-10.webp';
import servalProductPhoto11 from '../images/serval/product-photos-serval-11.webp';
import servalProductPhoto12 from '../images/serval/product-photos-serval-12.webp';
import servalProductPhoto13 from '../images/serval/product-photos-serval-13.webp';
import servalProductPhoto14 from '../images/serval/product-photos-serval-14.webp';

const StyledGallery = styled.section`
    background: ${(props) => props.theme.colors.yellow6};
    color: ${(props) => props.theme.colors.neutral10};
    padding: 1px;
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    flex-wrap: nowrap;
    gap: 1px;

    &::-webkit-scrollbar {
        display: none;
    }

    /* At larger screens switch from horizontal scroll to a responsive grid */
    @media (min-width: ${(props) => props.theme.breakpoints.fourth}) {
        display: grid;
        /* Choose a sensible min column width — adjust as needed */
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 1px;
        overflow: visible;
        scroll-snap-type: none;
        align-items: start;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.fifth}) {
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    }
`;

const ImageContainer = styled.div`
    flex: 0 0 calc(100% - 3rem);
    scroll-snap-align: start;

    img {
        display: block;
        width: 100%;
        height: auto;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.first}) {
        flex: 0 0 calc(50% - 1.5rem);
    }

    @media (min-width: ${(props) => props.theme.breakpoints.second}) {
        flex: 0 0 calc(33.333% - 1.5rem);
    }

    @media (min-width: ${(props) => props.theme.breakpoints.third}) {
        flex: 0 0 calc(25% - 1.5rem);
    }

    
    @media (min-width: ${(props) => props.theme.breakpoints.fourth}) {
        flex: initial;
        width: auto;
        scroll-snap-align: none;
        /* ensure images keep aspect ratio and fill the grid cell */
        img {
            width: 100%;
            height: auto;
            display: block;
        }
    }
`;

const images = [
    { src: servalProductPhoto6, alt: "Serval product photo 6" },
    { src: servalProductPhoto2, alt: "Serval product photo 2" },
    { src: servalProductPhoto3, alt: "Serval product photo 3" },
    { src: servalProductPhoto4, alt: "Serval product photo 4" },
    { src: servalProductPhoto5, alt: "Serval product photo 5" },
    { src: servalProductPhoto1, alt: "Serval product photo 1" },
    { src: servalProductPhoto7, alt: "Serval product photo 7" },
    { src: servalProductPhoto8, alt: "Serval product photo 8" },
    { src: servalProductPhoto9, alt: "Serval product photo 9" },
    { src: servalProductPhoto10, alt: "Serval product photo 10" },
    { src: servalProductPhoto11, alt: "Serval product photo 11" },
    { src: servalProductPhoto12, alt: "Serval product photo 12" },
    { src: servalProductPhoto13, alt: "Serval product photo 13" },
    { src: servalProductPhoto14, alt: "Serval product photo 14" }
];

export class ServalImagesBlock extends React.Component {
    render() {
        return (
            <StyledGallery>
                {images.map((image, index) => (
                    <ImageContainer key={index}>
                        <a href={image.src} target="_blank" rel="noopener noreferrer">
                            <img src={image.src} alt={image.alt} />
                        </a>
                    </ImageContainer>
                ))}
            </StyledGallery>
        );
    }
}